export class Batteries {
    id: string;
    user_id: string;
    name: string;
    description: string;
    created: string;
    modified: string;
    assessments: [
        {
            id: string;
            
        }
    ];
    assessment_short_names: [
         {
             name: string;
             
         }
     ];
     selected:false;
 
    constructor() { 
    }
 } 


// WEBPACK FOOTER //
// ./src/models/batteries.ts